import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isPermissionFormVisible } from '@selectors/admin';
import { Container } from '@layout/UsersManager';
import { UserList, EditUser } from '@organisms';
import { Panel, FlexContainer } from '@layout';

export class UsersManager extends PureComponent {
  static propTypes = {
    showEditUserForm: PropTypes.bool,
  };

  static defaultProps = {
    showEditUserForm: false,
  };

  render() {
    return (
      <Panel>
        <FlexContainer with="100%" gap="10px">
          <Container>
            <UserList />
          </Container>
          <Container>{this.props.showEditUserForm && <EditUser />}</Container>
        </FlexContainer>
      </Panel>
    );
  }
}

const mapStateToProps = (state) => ({
  showEditUserForm: isPermissionFormVisible(state),
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UsersManager);



// WEBPACK FOOTER //
// ./components/pages/AdminPage/UsersManager.js